
/**
 * 方法实现里，需要把能读到的参数都读出来，上报就要上报全面，有利于分析数据
 * @param params 上报的参数
 */
const logToServer = (params: any) => {
  let data = Object.assign({date:Date.now()}, params);
  // 添加全局参数
  data = Object.assign(data, readGlobalParams());
  // 添加浏览器参数
  data = Object.assign(data, readBrowserParams());
  if (process.env.NODE_ENV !== 'production') {
    console.log('开发环境，不上报bug，打印在控制台：', JSON.parse(JSON.stringify(data)));
  }
  // 表单
  const fd = new FormData();
  if (data['companyId']) {
    fd.append('companyId', data['companyId']);
    delete data.companyId;
  }
  if (data['site']) {
    fd.append('site', data['site']);
    delete data.site;
  }
  if (data['ru']) {
    fd.append('requestUrl', data['ru']);
    delete data.ru;
  }
  if (data['em']) {
    fd.append('reason', data['em']);
    delete data.em;
  }
  if (data['type']) {
    fd.append('type', data['type']);
  }
  if (data['time']) {
    fd.append('time', `${Math.ceil(Number(data['time']))}`);
    delete data.time;
  }
  if (data['cost']) {
    fd.append('cost', data['cost']);
    delete data.cost;
  }
  fd.append('param', JSON.stringify(data));
  
  if (process.env.NODE_ENV === 'production') {
    // 只有生产环境上报，开发环境不上报
    if (navigator?.sendBeacon) {
      navigator.sendBeacon('https://cartsee-form-c.cartx.cloud/cartsee/form/monitor/request', fd);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "https://cartsee-form-c.cartx.cloud/cartsee/form/monitor/request");
      xhr.send(fd);
    }
  } else {
    // 本地环境上报到
    if (navigator?.sendBeacon) {
      navigator.sendBeacon('https://test-service.cartsee-form-us.cartx.cloud/cartsee/form/monitor/request', fd);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "https://test-service.cartsee-form-us.cartx.cloud/cartsee/form/monitor/request");
      xhr.send(fd);
    }
  }
}

/**
 * 读取全局参数
 * @returns 全局参数
 */
const readGlobalParams = () => {
  const companyInfo = localStorage.getItem('companyInfo');
  return {
    companyId: companyInfo ? (JSON.parse(companyInfo)?.id ?? '') : '', // 公司id，有就传
    companyName: localStorage.getItem('companyName') ?? '', // 公司名称
    displayInfo: localStorage.getItem('displayInfo') ?? '', // 显示信息
  }
}

/**
 * 读取浏览器参数
 * @returns 浏览器参数
 */
const readBrowserParams = () => {
  return {
    site:window.location.href,
    ua:window.navigator?.userAgent,
  }
}

/**
 * 上报点击退订
 */
const logUnsubscribeInfo = (info: any) => {
  // 格式化报错
  let data:any = {
    type: 'PV',
  }
  if (typeof info != 'object') {
    data.error = `${info}`;
  } else {
    data = Object.assign({type:'PV'}, info);
  }
  // 进行上报
  logToServer(data);
}

export { logUnsubscribeInfo };

